import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="invite-to-chat"
export default class extends Controller {
  static values = {
    chatInputUrl: String
  }

  static targets = ["communitySpaceSelect"]

  connect() {
    this.communitySpaceSelectTarget.addEventListener("change", this.handleCommunitySpaceChange.bind(this))
  }

  handleCommunitySpaceChange(event) {
    const url = `${this.chatInputUrlValue}?community_space_id=${event.target.value}`
    Turbo.visit(url, { frame: "chat_input" })
  }
}
